import borders from './borders';
import colors from './colors';
import radii from './radii';
import shadows from './shadows';
import sizes from './sizes';
import space from './space';
import typography from './typography';
import zIndices from './zIndices';

// base colors required by theme UI
const themeUiColors = {
  background: colors['alabaster'],
  primary: colors.black,
  text: colors.black,
};

export default {
  borders,
  colors: { ...colors, ...themeUiColors },
  radii,
  shadows,
  sizes,
  space,
  text: typography.variants,
  zIndices,
};
